import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PlayerChoiceCountHandler from './playerChoiceCountHandler';
import Score from '../score/score';
import Game from '../game/game';
import TermActions from '../term-actions/termActions';
import VsBadge from '../vs-badge/vsBadge';
import PlayerChoiceCounts from '../player-choice-counts/playerChoiceCounts';

const initialVstime = 1000;
const skullTime = 1000;
const winTime = 1500;

export default class MultiplayerGame extends Component {
  constructor(props) {
    super(props);

    this.roundWin = this.roundWin.bind(this);
    this.roundLoss = this.roundLoss.bind(this);
    this.roundComplete = this.roundComplete.bind(this);
    this.onRoundAnswer = this.onRoundAnswer.bind(this);

    this.playerChoiceCountHandler = new PlayerChoiceCountHandler();

    this.state = {
      roundState: 'initial',
      answerState: 'none',
      answered: false,
      roundPlayerCount: 0,
      selectedAnswer: '',
      correctAnswer: '',
    };
  }

  componentDidMount() {
    this.beginNewRound();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.playerCount === nextProps.playerCount;
  }

  onRoundAnswer(answer) {

    setTimeout(() => {
      this.setState((prevState, props) => ({
        roundPlayerCount: props.playerCount,
        roundState: 'countdown',
        correctAnswer: answer
      }))
    }, initialVstime);
  }

  beginNewRound() {
    setTimeout(() => {
      this.setState({
        roundState: 'new',
        showAd: false,
        answered: false
      });
    }, 500);

    setTimeout(() => {
      this.setState({ roundState: 'countdown' });
    }, 1200);
  }

  roundWin(highOrLow) {
    this.props.onPlayerAnswered(highOrLow);

    this.setState((prevState, props) => ({
      answerState: 'win',
      selectedAnswer: highOrLow
    }));
  }

  roundLoss(highOrLow) {
    this.props.onPlayerAnswered(highOrLow);

    this.setState((prevState, props) => ({
      answerState: 'loss',
      selectedAnswer: highOrLow
    }));
  }

  async roundComplete() {
    this.setState((prevState, props) => ({
      roundState: 'processing', 
      answered: true, 
      selectedAnswer: 'unanswered',
    }));

    setTimeout(() => {
      this.setState((prevState, props) => ({
        roundState: this.state.answerState === 'win' ? 'win' : 'loss'
      }))

      if (this.state.answerState !== 'win') {
        setTimeout(() => {
          console.log('test ' + this.state.roundPlayerCount);
          this.props.onRoundLost(this.state.roundPlayerCount);
        }, winTime);
        return;
      }

      setTimeout(() => {
        this.props.onRoundWon();
        this.setState((prevState, props) => ({
          roundState: 'new',
          answerState: 'none',
          selectedAnswer: '',
          correctAnswer: '',
          answered: false
        }));
      }, 1800);

    }, skullTime);
  }

  renderPlayerChoices() {
    if (this.state.selectedAnswer !== '') {
      return (
        <PlayerChoiceCounts 
          higherCount={this.props.remoteHigherCount} 
          lowerCount={this.props.remoteLowerCount} 
          selectedAnswer={this.state.selectedAnswer} 
          correctAnswer={this.state.correctAnswer} 
          answered={this.state.answered} />
      )
    }
  }

  render() {
    return (
      <div className='game-container'>
        <div className='score-bar score-bar--multiplayer'>
          <Score score={this.props.playerCount} label='Player Count' />
        </div>
        <Game
          terms={this.props.terms}
          onIncorrectAnswer={this.roundLoss}
          onCorrectAnswer={this.roundWin}
          roundState={this.state.roundState}
          answered={this.state.answered}
          actions={<TermActions hidden={this.state.selectedAnswer !== ''} />}
          badge={<VsBadge 
            roundState={this.state.roundState} 
            timerStartSeconds={this.props.timeLimitSeconds} 
            onTimeOut={this.roundComplete} 
          />} 
          onRoundAnswer={this.onRoundAnswer} />
        {this.renderPlayerChoices()}
      </div>
    );
  }
}

MultiplayerGame.propTypes = {
  terms: PropTypes.array, 
  playerCount: PropTypes.number,
  onRoundLost: PropTypes.func,
  onRoundWon: PropTypes.func,
  onPlayerAnswered: PropTypes.func,
  timeLimitSeconds: PropTypes.number,
  remoteHigherCount: PropTypes.number,
  remoteLowerCount: PropTypes.number
}


// WEBPACK FOOTER //
// ./src/components/elimination-game/eliminationGame.js